// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__fef6efa6974fc8e3c5c5","cls2":"Unibrow-cls2___b77cef9539f2631140b Unibrow-cls1__fef6efa6974fc8e3c5c5"};